// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA4V18xRUkktczW-v-t_D5I5lZGWVmKh9w",
  authDomain: "work-place-1999.firebaseapp.com",
  projectId: "work-place-1999",
  storageBucket: "work-place-1999.appspot.com",
  messagingSenderId: "835479638156",
  appId: "1:835479638156:web:ee245f61f08577fedaeba9",
  measurementId: "G-E592W504Z4"
};
export default firebaseConfig;
// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// const auth = getAuth(app);
